<template>
	<section class="sidebar-lottery">
		<button
			class="sidebar-lottery-info"
			type="button"
			:aria-label="$t('couponLottery.rules_btn')"
			@click="$emit('open-rules')"
		>
			<i class="fa fa-info" aria-hidden="true"></i>
		</button>
		<p class="sidebar-lottery-eyebrow">★ {{ $t('couponLottery.daily_draw_title') }} ★</p>
		<div class="sidebar-lottery-title">
			<strong>{{ $t('coupon.activity_button_text') }}</strong>
		</div>
		<p class="sidebar-lottery-range">10% <span>~</span> 30% {{ $t('coupon.discount_label') }}</p>
		<div class="sidebar-lottery-stage" aria-hidden="true">
			<div class="sidebar-coupon-options">
				<span>10%</span>
				<span>20%</span>
				<span>30%</span>
			</div>
			<div class="sidebar-coupon-ticket">
				<span>{{ $t('coupon.discount_label') }}</span>
				<div class="sidebar-coupon-value"><small>最高</small><strong>30%</strong></div>
			</div>
		</div>
		<div class="sidebar-lottery-divider"></div>
		<button class="sidebar-activity bg_color" type="button" @click="$emit('open-lottery')">
			<span>立即抽獎</span>
		</button>
		<p class="sidebar-lottery-status">
			{{ $t('couponLottery.unlocked_extra', { amount: lotteryCount }) }}
		</p>
	</section>
</template>

<script>
export default {
	name: 'RebateCouponLotteryCard',
	props: {
		lotteryCount: {
			type: [Number, String],
			default: 0
		}
	}
}
</script>

<style scoped>
.sidebar-lottery {
	position: relative;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	min-height: 365px;
	padding: 16px 16px 14px;
	flex-direction: column;
	border: 1px solid #e2e5e8;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0 3px 12px rgba(31, 41, 55, .06);
}

.sidebar-lottery-info {
	position: absolute;
	top: 10px;
	right: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	padding: 0;
	border: 1px solid #dfe3e8;
	border-radius: 50%;
	background: #fff;
	color: #68717c;
	font-size: 13px;
	cursor: pointer;
	box-shadow: 0 2px 6px rgba(31, 41, 55, .08);
}

.sidebar-lottery-eyebrow {
	margin-top: 2px;
	color: #7b8490;
	font-size: 12px;
	line-height: 18px;
	text-align: center;
}

.sidebar-lottery-title {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #272b30;
	font-size: 20px;
	line-height: 30px;
}

.sidebar-lottery-range {
	margin-top: 3px;
	color: #ef5a2a;
	font-size: 26px;
	font-weight: 600;
	line-height: 36px;
	text-align: center;
}

.sidebar-lottery-range span {
	display: inline-block;
	margin: 0 4px;
	font-weight: 400;
}

.sidebar-lottery-stage {
	position: relative;
	width: 100%;
	height: 150px;
	margin-top: 4px;
}

.sidebar-coupon-options {
	position: absolute;
	top: 14px;
	left: 50%;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	width: 254px;
	transform: translateX(-50%);
}

.sidebar-coupon-options span {
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: 74px;
	height: 52px;
	border: 1px dashed #cfd5db;
	border-radius: 6px;
	background: #fff;
	color: #ad4926;
	font-size: 18px;
	font-weight: 500;
	box-shadow: 0 2px 6px rgba(31, 41, 55, .06);
}

.sidebar-coupon-options span:first-child {
	transform: rotate(-2deg);
}

.sidebar-coupon-options span:last-child {
	transform: rotate(2deg);
}

.sidebar-coupon-ticket {
	position: absolute;
	top: 70px;
	left: 50%;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: 166px;
	height: 80px;
	flex-direction: column;
	border: 1px solid #efb77f;
	border-radius: 7px;
	background: #fff7ef;
	color: #ad4926;
	transform: translateX(-50%);
	box-shadow: 0 4px 12px rgba(172, 73, 35, .1);
}

.sidebar-coupon-ticket::before,
.sidebar-coupon-ticket::after {
	content: '';
	position: absolute;
	top: 50%;
	width: 14px;
	height: 14px;
	border-radius: 50%;
	background: #fff;
	transform: translateY(-50%);
}

.sidebar-coupon-ticket::before {
	left: -9px;
}

.sidebar-coupon-ticket::after {
	right: -9px;
}

.sidebar-coupon-ticket span {
	font-size: 13px;
	line-height: 20px;
}

.sidebar-coupon-ticket strong {
	font-size: 30px;
	font-weight: 500;
	line-height: 38px;
}

.sidebar-coupon-value {
	display: flex;
	align-items: baseline;
	justify-content: center;
	gap: 4px;
}

.sidebar-coupon-value small {
	font-size: 13px;
	line-height: 20px;
}

.sidebar-lottery-divider {
	width: calc(100% - 18px);
	margin: 1px 0 14px;
	border-top: 1px solid #eceff2;
}

.sidebar-activity {
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: calc(100% - 64px);
	min-height: 48px;
	margin-top: 0;
	gap: 10px;
	border: 0;
	border-radius: 24px;
	background: #f35a2a;
	color: #fff;
	font-size: 16px;
	font-weight: 700;
	cursor: pointer;
	box-shadow: 0 4px 10px rgba(223, 75, 24, .18);
}

.sidebar-lottery-status {
	margin-top: 10px;
	color: #7b8490;
	font-size: 12px;
	line-height: 18px;
	text-align: center;
}

@media (max-width: 767px) {
	.sidebar-activity {
		min-height: 1.1rem;
		border-radius: .16rem;
		font-size: 15px;
	}
}
</style>
